import * as React from 'react';
import {FunctionComponent} from 'react';
import {UpcomingEvents} from '../../../Components/Crew/UpcomingEvents';
import {YourCrew} from './YourCrew';
import {CrewMembers} from './CrewMembers';
import {Feedback} from '../../../Components/Feedback';
import {DeleteCrew} from './DeleteCrew';
import {FullCrew} from '../../../../Models/Crew';
import {Link} from 'react-router-dom';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    fullCrew: FullCrew;
}

export const Sidebar: FunctionComponent<OwnProps> = ({fullCrew}) => {
    return (
        <>
            <ul className="list-group mb-3 d-none d-lg-flex">
                <li
                    className={classNames('list-group-item', {
                        active: window.location.pathname === '/crews/' + fullCrew.id,
                    })}
                >
                    <Link to={'/crews/' + fullCrew.id}>Overview</Link>
                </li>
                <li
                    className={classNames('list-group-item', {
                        active: window.location.pathname === '/crews/' + fullCrew.id + '/calendar',
                    })}
                >
                    <Link to={'/crews/' + fullCrew.id + '/calendar'}>Calendar</Link>
                </li>
            </ul>
            <UpcomingEvents crewScopes={[fullCrew]} className="mb-3" />
            <YourCrew className="mb-3" crew={fullCrew} />
            <CrewMembers className="mb-3" crew={fullCrew} members={fullCrew.members} />
            <Feedback className="mb-3" />
            <DeleteCrew crew={fullCrew} />
        </>
    );
};
